import { render, staticRenderFns } from "./FpVerify.vue?vue&type=template&id=b565fc8c&scoped=true&"
import script from "./FpVerify.vue?vue&type=script&lang=js&"
export * from "./FpVerify.vue?vue&type=script&lang=js&"
import style0 from "./FpVerify.vue?vue&type=style&index=0&id=b565fc8c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b565fc8c",
  null
  
)

export default component.exports